























import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class ModalSuccess extends Vue {
  @Prop({ default: 'modal-success' }) private id!: string
  @Prop() private successMess!: string
  @Prop({ default: 3 }) private closeSeconds!: number
  @Prop({ default: true }) private autoClose!: boolean

  hideModal() {
    this.$bvModal.hide(this.id)
    setTimeout(() => {
      this.$emit('close')
      clearTimeout()
    }, 300)
  }

  hanldeAutoClose() {
    if (this.autoClose) {
      setTimeout(() => {
        this.$bvModal.hide(this.id)
        clearTimeout()
      }, this.closeSeconds * 1000)
    }
  }
}
